export const visaTypeTutorial = 'https://www.youtube.com/embed/yKtspbBskGM'
export const visaSubTypeTutorial = 'https://www.youtube.com/embed/_wksakg4Fm8'